import React, { ReactElement } from 'react';

import { getIconAsset } from './Icon.assets';
import { ICON_COLOR } from './Icon.colors';
import { iconDisplayName } from './Icon.qa';
import { ICON_TYPE } from './Icon.types';

export * from './Icon.types';
export * from './Icon.colors';

export enum ICON_SIZE {
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large',
}

export interface IIconProps {
    type: ICON_TYPE;
    size?: ICON_SIZE;
    color?: ICON_COLOR;
    alt?: string;
    className?: string;
    'data-testid'?: string;
}

const iconClassNames: Record<ICON_TYPE, Record<string, string>> = {
    [ICON_TYPE.OZ_HELP_TIP]: {
        [ICON_SIZE.SMALL]: 'h-3/2 w-3/2',
        [ICON_SIZE.MEDIUM]: 'h-2 w-2',
    },
    [ICON_TYPE.OZ_ARROW_RIGHT]: {
        [ICON_SIZE.SMALL]: 'h-1 w-1',
        [ICON_SIZE.MEDIUM]: 'h-3/2 w-1',
    },
    [ICON_TYPE.OZ_ARROW_UP]: {
        [ICON_SIZE.SMALL]: 'h-1 w-1',
        [ICON_SIZE.MEDIUM]: 'h-3/2 w-2',
        [ICON_SIZE.LARGE]: 'h-3 w-3',
    },
    [ICON_TYPE.OZ_ARROW_DOWN]: {
        [ICON_SIZE.SMALL]: 'h-1 w-1',
        [ICON_SIZE.MEDIUM]: 'h-3/2 w-2',
        [ICON_SIZE.LARGE]: 'h-3 w-3',
    },
    [ICON_TYPE.OZ_YOUTUBE]: {},
    [ICON_TYPE.OZ_INSTAGRAM]: {},
    [ICON_TYPE.OZ_TWITTER]: {},
    [ICON_TYPE.OZ_TIKTOK]: {},
    [ICON_TYPE.OZ_FACEBOOK]: {},
    [ICON_TYPE.OZ_ACCOUNT_AVATAR]: {},
    [ICON_TYPE.OZ_CLOSE]: {},
    [ICON_TYPE.OZ_PROMO_TAG]: {},
    [ICON_TYPE.OZ_CHARITY_ICON]: {},
    [ICON_TYPE.OZ_SAND_TIMER]: {},
    [ICON_TYPE.OZ_CLOCK_TIMER]: {},
};

function computeSizeClass (type: ICON_TYPE, size: string = ICON_SIZE.SMALL): string {
    return iconClassNames[type][size] || '';
}

export function OzIcon (props: IIconProps): ReactElement {
    const {
        size,
        className = '',
        'data-testid': dataTest,
        color = ICON_COLOR.DARK,
        type,
        alt = '',
    }: IIconProps = props;

    const sizeClass: string = computeSizeClass(type, size);
    const iconAsset: string = getIconAsset(type, color);

    return (
        <img
            className={`${sizeClass} ${className}`}
            data-testid={dataTest}
            src={iconAsset}
            alt={alt}
        />
    );
}

OzIcon.displayName = iconDisplayName;
